import { createElement, memo } from "@max/max";
import LeezImage from '@max/leez-image';
import { toPx, setRemConfig } from '@max/leez-style-util';
setRemConfig({
    enabled: true
});
const AutoImage = (props) => {
    const { uri, styles } = props || {};
    const _toPx = (px) => {
        return toPx(px, {
            enabled: true,
            designWidth: 750
        });
    };
    let leezStyle = {};
    // 如果设置了宽度，优先用这个宽度
    if (!styles.widthRpx && !styles.heightRpx) {
        leezStyle = {
            widthAuto: false
        };
    }
    else if (!styles.widthRpx) {
        leezStyle = {
            widthAuto: false,
            height: _toPx(styles.heightRpx)
        };
    }
    else if (!styles.heightRpx) {
        leezStyle = {
            heightAuto: false,
            width: _toPx(styles.widthRpx)
        };
    }
    else {
        leezStyle = {
            height: _toPx(styles.heightRpx),
            width: _toPx(styles.widthRpx)
        };
    }
    return <LeezImage {...leezStyle} useFallback={false} resizeMode={'stretch'} source={{
            uri
        }}/>;
};
export default memo(AutoImage);
